/*
|--------------------------------------------------------------------------
| Utility: quillConfig.js
| Author: Sayed Ahmed
| Description: Configuration for the React Quill editor, including toolbar
|              modules, font options, colors, and sizes.
|--------------------------------------------------------------------------
*/

// Available text colors and background highlights
export const quillColors = [
  "#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff",
  "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666",
  "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00",
  "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600",
  "#003700", "#002966", "#3d1466", "#000000", "#990000", "#b26b00", "#b2b200", "#005c00",
  "#003399", "#592966",
];

// Font families available in the font selector
export const quillFonts = [
  "Arial",
  "Tahoma",
  "Times New Roman",
  "Courier New",
  "Roboto",
];

// Font sizes: false = default
export const quillFontSizes = ["small", false, "large", "huge"];

// Quill modules configuration for toolbar and clipboard
export const quillModules = {
  toolbar: {
    container: [
      [{ font: quillFonts }], // Font selector
      [{ size: quillFontSizes }], // Font size selector
      [{ header: [1, 2, 3, 4, 5, 6, false] }], // Headings
      [{ color: quillColors }, { background: quillColors }], // Text color and background
      ["bold", "italic", "underline", "strike"], // Text styles
      ["link", "video"], // Media embeds
      [{ list: "ordered" }, { list: "bullet" }], // Lists
      [{ align: [] }, { direction: "rtl" }], // Alignment and direction
      ["clean"], // Remove formatting
    ],
  },
  clipboard: {
    matchVisual: false, // Prevent Quill from adding inline styles
  },
};
